module.exports = __webpack_public_path__ + "static/media/calculator-icon.51006abd.svg";